/**
 * Version-string helpers for the prompt/rubric versioning story.
 *
 * Versions look like "prompts-v1.1" or "dental-interview-v1.0". Bumping the
 * minor number is how the app invalidates the score cache when prompt content
 * changes (the cache key includes the prompt version).
 */

const VERSION_RE = /^(.*v)(\d+)\.(\d+)$/;

/** "prompts-v1.1" -> "prompts-v1.2". Unrecognized formats get "-2", "-3", … */
export function bumpVersion(version: string): string {
  const m = version.match(VERSION_RE);
  if (m) return `${m[1]}${m[2]}.${Number(m[3]) + 1}`;
  const tail = version.match(/^(.*-)(\d+)$/);
  if (tail) return `${tail[1]}${Number(tail[2]) + 1}`;
  return `${version}-2`;
}
